import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import VideoCard from '../components/VideoCard';
import { api } from '../api';
import { HomeSkeleton } from '../components/LoadingSkeleton';

export default function Home() {
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter');
  const rawSearch = searchParams.get('search') || '';
  const search = rawSearch.trim().toLowerCase();
  const [trending, setTrending] = useState([]);
  const [popular, setPopular] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    // Single unified fetch for all catalogue data
    api.getVideos().then((videos) => {
      if (cancelled) return;
      const list = Array.isArray(videos) ? videos : (Array.isArray(videos?.data) ? videos.data : []);
      setAllVideos(list);
      setTrending(list.filter((v) => v.is_trending));
      setPopular(list.filter((v) => v.is_popular));
      setLoading(false);
    }).catch((err) => {
      console.warn('Catalogue fetch error:', err);
      if (!cancelled) setLoading(false);
    });

    return () => { cancelled = true; };
  }, []);

  if (loading) return <HomeSkeleton />;

  const matches = (v) =>
    !search || `${v.title} ${v.genre || ''} ${v.description || ''}`.toLowerCase().includes(search);

  const filtered = filter
    ? allVideos.filter(v => filter === 'movies' ? v.type === 'single' : v.type === 'series')
    : allVideos;

  const trendingIds = new Set(trending.map(v => v.id));
  const popularIds = new Set(popular.map(v => v.id));

  if (search) {
    const results = filtered.filter(matches);

    return (
      <div className="home-page">
        <section className="videos-section">
          <h2 className="section-title">Search results for &ldquo;{rawSearch}&rdquo;</h2>
          <div className="videos-grid">
            {results.map((item) => (
              <VideoCard key={item.id} item={item} type={item.type} />
            ))}
            {results.length === 0 && (
              <p className="search-empty">No movies or TV shows match your search.</p>
            )}
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="home-page">
      {!filter && (
        <>
          {trending.length > 0 && (
            <section className="videos-section">
              <h2 className="section-title">Trending Now</h2>
              <div className="videos-grid">
                {trending.map((item) => (
                  <VideoCard key={item.id} item={item} type={item.type} />
                ))}
              </div>
            </section>
          )}

          {popular.length > 0 && (
            <section className="videos-section">
              <h2 className="section-title">Popular</h2>
              <div className="videos-grid">
                {popular.map((item) => (
                  <VideoCard key={item.id} item={item} type={item.type} />
                ))}
              </div>
            </section>
          )}
        </>
      )}

      <section className="videos-section">
        <h2 className="section-title">
          {filter === 'movies' ? 'All Movies' : filter === 'series' ? 'All Series' : 'All Videos'}
        </h2>
        <div className="videos-grid">
          {filtered
            .filter((item) => filter || (!trendingIds.has(item.id) && !popularIds.has(item.id)))
            .map((item) => (
              <VideoCard key={item.id} item={item} type={item.type} />
            ))}
        </div>
      </section>
    </div>
  );
}
